module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/flow_arrow_mobile-968a058e151ecf984144ff985662d41b.svg";